import React, { Component } from 'react';
import { Modal, ModalBody, ModalFooter, Button } from 'reactstrap';

class ConfirmModal extends Component {

    render() {
        return (
            <>
                <Modal centered isOpen={this.props.isOpen}>
                    <ModalBody>
                        {this.props.body != null ? this.props.body : 'Are you sure you wish to proceed?'}
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color={this.props.color != null ? this.props.color : 'danger'}
                            onClick={this.props.executeAction}
                        >
                            {this.props.action != null ? this.props.action : 'Yes'}
                        </Button>
                        <Button
                            onClick={this.props.hideConfirmModal}
                            color={this.props.cancelColor != null ? this.props.cancelColor : 'secondary'}
                        >
                            {this.props.cancel != null ? this.props.cancel : 'Cancel'}
                        </Button>
                    </ModalFooter>
                </Modal>
            </>)
    }
};

export default ConfirmModal;